import React, { useState, useEffect } from "react";
import { Container, ExpressionLine, AddButtonArea, ButtonArea, ActionArea, FormArea, IndexNumber, TitleArea } from "./Styled";
import { Formik, Form, FieldArray, FormikValues, FastField, FormikErrors, FormikTouched } from "formik";
import { Input } from "formik-antd";
import { Button, Tag, Alert, Upload } from "antd";
import * as Yup from "yup";
import WrapEntityAnnotator from "../IntentAnnotator/TokenAnnotator/WrapEntityAnnotator"
import { Intent } from "../../../../model/intent/types";
import { useDispatch } from "react-redux";
import Header from "../../../system/header";
import SaveButton from "../../../system/saveButton/SaveButton";
import { buildIntent, saveIntentAction, deleteIntentAction } from "../../../../business/actions/intentActions";
import ConfirmButton from "../../../system/confirmButton/ConfirmButton";
import { useIntl } from "react-intl";
import { RcFile } from "antd/lib/upload";
import { UploadOutlined } from "@ant-design/icons";
import IntentAlert from "./IntentAlert/IntentAlert";

type IntentFormProps = {
  intent?: Intent | null
};

const SignupSchema = Yup.object().shape({
  title: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required')
});

const IntentForm: React.FunctionComponent<IntentFormProps> = ({ intent }) => {
  const dispatch = useDispatch()
  const intl = useIntl();
  const [currentIntent, setcurrentIntent] = useState<Intent | undefined | null>(undefined);

  useEffect(() => {
    setcurrentIntent(intent);
  }, [intent])

  const save = (values: FormikValues) => {
    // @ts-ignore
    const intentToSave: Intent = {
      title: values.title,
      expressions: values.sentences,
      id: currentIntent?.id
    };
    dispatch(saveIntentAction.request(intentToSave));
    setcurrentIntent(intentToSave)
  }

  const onDelete = (intentId: string) => {
    dispatch(deleteIntentAction.request(intentId));
  }

  const onBuild = (intentId: string) => {
    dispatch(buildIntent(intentId));
  }

  // DIRTY TO REFACTOR
  const handleImport = (file: RcFile, FileList: RcFile[]) => {
    const reader = new FileReader()
    reader.onload = async (e) => {
      // @ts-ignore
      const text = (e.target.result)
      const intentRegex = /- .*/g;
      // @ts-ignore
      const found = text.match(intentRegex);

      const tagRegex = /\([a-zA-Z_]*\)/g;
      var expressions = found.map((item: string) =>
        ({
          // @ts-ignore
          text: item.replaceAll("- ", "").replaceAll("[", "").replaceAll("]", "").replaceAll(tagRegex, "")
        })
      )

      const intentToSet: Intent = new Intent(currentIntent!.title, expressions);
      setcurrentIntent(intentToSet)
    };
    reader.readAsText(file)
    return false;
  };


  const renderHeader = (values: FormikValues, errors: FormikErrors<any>, touched: FormikTouched<any>) => {
    return <Header>
      <TitleArea>
        <Input name='title' value={values.title} placeholder="Titre"></Input>
        {errors.title && touched.title ? (
          <Alert message={errors.title} type="error" showIcon />
        ) : null}
      </TitleArea>
      <ActionArea>
        <ButtonArea>
          <Upload beforeUpload={handleImport}>
            <Button icon={<UploadOutlined />}>Import</Button>
          </Upload>
        </ButtonArea>
        <ButtonArea>
          <Button onClick={() => onBuild(values.id)}>Build</Button>
        </ButtonArea>
        <ButtonArea>
          <ConfirmButton onConfirm={() => onDelete(values.id)} confirmTitle={intl.formatMessage({ id: 'entity_manager.delete_confirm' })} danger>Supprimer</ConfirmButton>
        </ButtonArea>
        <ButtonArea>
          <SaveButton />
        </ButtonArea>
      </ActionArea>
    </Header>
  }

  return (
    <Container>
      <Formik
        validationSchema={SignupSchema}
        enableReinitialize
        initialValues={{ id: currentIntent?.id, title: currentIntent?.title, sentences: currentIntent ? currentIntent.expressions : [] }}
        onSubmit={(values) => {
          save(values);
        }}
        render={({ values, errors, touched }) => {
          return <Form>
            {renderHeader(values, errors, touched)}
            <FormArea>
              {currentIntent && <IntentAlert intent={currentIntent}/>}
              <FieldArray
                name="sentences"
                render={arrayHelpers => (
                  <div>
                    {
                      values.sentences.map((expression, index) => (
                        <ExpressionLine key={index}>
                          <IndexNumber><Tag>{index}</Tag></IndexNumber>
                          <FastField name={`sentences.${index}`} value={expression} component={WrapEntityAnnotator} />
                          <ButtonArea>
                            <Button
                              danger
                              onClick={() => arrayHelpers.remove(index)} // remove a friend from the list
                            >
                              -
                        </Button>
                          </ButtonArea>
                        </ExpressionLine>
                      ))
                    }
                    <AddButtonArea>
                      <Button
                        onClick={() => arrayHelpers.push(undefined)} // insert an empty string at a position
                      >
                        +
                  </Button>
                    </AddButtonArea>
                  </div>
                )}
              />
            </FormArea>
          </Form>
        }}
      />
    </Container>
  );
};

export default IntentForm;
